import { BffCmsHeroBackground, BffCmsHeroBackgroundResponse } from '@lucky7ventures/bff-types';
import {
  HeroBackgroundsActions,
  HeroBackgroundsActionType,
} from '@/store/cms/hero-backgrounds/actions';

export interface HeroBackgroundsState {
  heroBackgrounds: BffCmsHeroBackgroundResponse;
  loading: boolean;
  error: boolean;
}

const initialHeroBackgrounds: BffCmsHeroBackground = {
  authenticated: {
    mobile: null,
    desktop: null,
    tablet: null,
  },
  unauthenticated: {
    mobile: null,
    desktop: null,
    tablet: null,
  },
};

const initialState: HeroBackgroundsState = {
  heroBackgrounds: initialHeroBackgrounds,
  loading: false,
  error: false,
};

export const heroBackgroundsReducer = (
  state = initialState,
  action: HeroBackgroundsActions,
): HeroBackgroundsState => {
  switch (action.type) {
    case HeroBackgroundsActionType.GetHeroBackgrounds:
      return { ...state, loading: true, error: false };
    case HeroBackgroundsActionType.GetHeroBackgroundsError:
      return { ...state, heroBackgrounds: initialHeroBackgrounds, loading: false, error: true };
    case HeroBackgroundsActionType.GetHeroBackgroundsSuccess: {
      return {
        ...state,
        heroBackgrounds: action.heroBackgrounds,
        loading: false,
        error: false,
      };
    }
    default:
      return state;
  }
};
